import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer: React.FC = () => (
  <Box
    component="footer"
    sx={{
      bgcolor: 'primary.main',
      color: 'common.white',
      py: 2,
      textAlign: 'center',
      mt: 'auto',
    }}
  >
    <Typography variant="body2">
      © Copyright 2026 NsLab. All rights reserved.
    </Typography>
  </Box>
);

export default Footer;
